export default class heroVideoControls {
    constructor() {
        let videoWrapper, video;

        if (screen.width > 768) {
            videoWrapper = document.querySelector('#onbeperkt-series-films-v1.desktop .et_pb_section_video_bg');
            video = document.querySelector('#onbeperkt-series-films-v1.desktop video');
        } else {
            videoWrapper = document.querySelector('#onbeperkt-series-films-v1.mobile .et_pb_section_video_bg');
            video = document.querySelector('#onbeperkt-series-films-v1.mobile video');
        }

        video.volume = 0.5;

        const controlWrapper = document.createElement('div');
        controlWrapper.classList = 'control-wrapper';

        const playButton = document.createElement('button');
        playButton.classList = 'control playing';

        const volumeButton = document.createElement('button');
        volumeButton.classList = 'volume muted';

        playButton.addEventListener('click', () => {
            playButton.classList.contains('playing') ? video.pause() : video.play();
            playButton.classList.toggle('playing');
        });

        volumeButton.addEventListener('click', () => {
            volumeButton.classList.contains('muted') ? video.muted = false : video.muted = true;
            volumeButton.classList.toggle('muted');
        });

        controlWrapper.insertAdjacentElement('beforeend', playButton);
        controlWrapper.insertAdjacentElement('beforeend', volumeButton);
        videoWrapper.insertAdjacentElement('beforeend', controlWrapper);

        video.play();
    }
}